import React from 'react'

const IconMoon = () => {
    return (
        <svg className="block h-6 dark:hidden" viewBox="0 0 246 263" aria-hidden="true">
            <path d="M117.234 131.5c0-51.54 29.63-96.147 72.766-117.708C172.353 4.97 152.45 0 131.383 0 58.822 0 0 58.874 0 131.5S58.822 263 131.383 263c21.066 0 40.97-4.971 58.617-13.792-43.136-21.561-72.766-66.168-72.766-117.708z"/>
        </svg>
    )
}

export default IconMoon
